import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
	createStyles({
		footer: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			top: 'auto',
			bottom: 0,
            textAlign: 'center',			
		},
		footerToolbar: {
			[theme.breakpoints.down("xs")]: {
				flexDirection: "column",
				alignItems: "flex-start",
				minHeight: "auto",      // odstrani fiksno 56px višino
				paddingTop: 4,
				paddingBottom: 4,
				"& > *": {
				marginBottom: 2,      // enoten majhen razmik med vsemi otroki
				lineHeight: 1.2,      // stisne višino vrstic
				},
			},
			},
	})
);
